import axios from "axios";

const api = {
  post: async (link, data) => {
    const res = await axios.post(
      "https://www.uptodateconnect.com/api/v1/blogger/proxy",
      {
        url: "http://etim-mapper.com/api/rofix" + link,
        method: "GET",
        headers: {
          ContentType: "application/json",
        },
        auth: {
          username: "1376f86b11b64af4bf138328a7014d64",
          password: "8e26035649cc14d1475742d01a4b5c18",
        },
        ...(data ? { data } : {}),
      }
    );
    return res.data;
  },
};

export default api;
